"use client";

import Header from "@/components/home/Header";
// import Navigator from "@/components/home/Navigator";
import ProductTable from "@/components/home/ProductTable";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { CircularProgress } from "@mui/material";
import { fetchCart } from "@/store/slices/cartSlice";
import { useAppDispatch, useAppSelector } from "@/hooks/useAppSelector";

const BulkOrders: React.FC = () => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const { isAuthenticated, token, phoneNumber } = useAppSelector(
    (state) => state.auth
  );


  useEffect(() => {
    if (!isAuthenticated || !token) {
      router.push("/auth");
    } else {
      dispatch(fetchCart(phoneNumber));
    }
  }, [dispatch, isAuthenticated, token, router, phoneNumber]);

  return (
    <>
      {!isAuthenticated ? (
        <div className="w-full min-h-screen flex justify-center items-center">
          <CircularProgress size={40} sx={{ color: "var(--color-blue)" }} />
        </div>
      ) : (
        <div>
          <div
            style={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Header />
          </div>
          {/* <Navigator /> */}
          <ProductTable />
        </div>
      )}
    </>
  );
};

export default BulkOrders;